<template>
    <cadastro-simples-list
        endpoint="grupo-conceito"
        rota-base="/admin/grupo-conceito"
        titulo="GRUPOS DE CONCEITO"
        titulo-singular="Grupo de Conceito"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
